// extracted by mini-css-extract-plugin
export var container = "category-container-module--container--QKQaK";
export var titleBox = "category-container-module--titleBox--XGrJA";